import { Compass, LinkedinLogo, Plugs } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";
import RadioButton from "common/components/ui/RadioButton";
import type { WorkspaceAccount } from "common/types";

import LicenseIcon from "assets/icons/license.svg?react";
import RentedIcon from "assets/icons/rented.svg?react";

interface AccountCardProps {
  account: WorkspaceAccount;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export default function AccountCard({
  account,
  isSelected,
  onSelect,
}: AccountCardProps) {
  const {
    id,
    full_name: fullName,
    picture_url: pictureUrl,
    occupation,
    premium: isPremium,
    sales_navigator: isSalesNavigator,
    state,
    type,
    license,
  } = account;

  const isLoggedIn = state === "LoggedIn";

  return (
    <button
      key={id}
      type="button"
      onClick={() => onSelect(id)}
      className={clsx(
        "flex items-center gap-x-2 rounded-3xl border p-3 transition-colors",
        isSelected
          ? "border-purple-500 bg-purple-50"
          : "border-black-200 hover:bg-black-100",
      )}
    >
      <div className="relative">
        <ProfileImage src={pictureUrl} />

        {type === "rental" ? (
          <RentedIcon className="absolute -bottom-1 -right-[5px]" />
        ) : (
          <RenderIf condition={!!license}>
            <LicenseIcon className="absolute -bottom-1 -right-[5px]" />
          </RenderIf>
        )}
      </div>

      <div className="flex flex-1 flex-col items-start">
        <div className="flex items-center gap-x-1">
          <span className="text-sm-bold line-clamp-1 break-all">
            {fullName}
          </span>

          {isLoggedIn ? (
            <>
              <RenderIf condition={isPremium}>
                <LinkedinLogo
                  size={16}
                  weight="fill"
                  className="fill-yellow-500"
                />
              </RenderIf>

              <RenderIf condition={isSalesNavigator}>
                <Compass size={16} weight="fill" className="fill-blue-500" />
              </RenderIf>
            </>
          ) : (
            <Plugs weight="fill" className="fill-black-400" size={16} />
          )}
        </div>
        <span className="text-xs-medium line-clamp-1 break-all text-left text-black-500">
          {occupation}
        </span>
      </div>

      <RadioButton checked={isSelected} isStyleOnly />
    </button>
  );
}
